
import { Vue, Component } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getInformationList, InformationListDTO } from '@/api/information'
import { bannerDto, getAdvertisementList } from '@/api/homes'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
import BannerSwiper from '@/views/homes/BannerSwiper.vue'
import ShopList from '@/views/information/template/shopList.vue'

@Component({
  components: {
    BannerSwiper,
    ShopList
  }
})
export default class Information extends Vue {
  @Getter logoUrl: string // 公司头像
  @Getter info: LoginReturnDataDto
  pageIndex = 1
  pageSize = 10
  refreshing = false
  loading = false
  finished = false

  informationList: InformationListDTO[] = []

  banners: bannerDto[] = []

  toSearch () {
    this.$router.push({
      path: '/searchHomes'
    })
  }

  created () {
    this.getAdvertisementList()
    this.getInformationList()
  }

  toBack() {
    this.$router.back()
  }

  /**
   * 获取banner图
   */
  getAdvertisementList () {
    let parma = {
      // companyId: '61af0a93d5e8c8706479258d',
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      // partnerCompanyId:'62f315b5d5e8c81a7d7881e5',
      deliverArea: '2' // 1 首页 2 资讯页
    }
    getAdvertisementList(parma).then(res => {
      this.banners = res.data.advertisementList
    })
  }

  handleInformation (inform: InformationListDTO) {
    this.$router.push({
      name: 'InformationDetail',
      query: {
        informationId: inform.informationId,
        publishTime: inform.publishTime,
        companyShortName: inform.companyShortName,
        title: inform.title,
        visitsNumber: inform.visitsNumber + ''
      }
    })
  }

  getInformationList () {
    getInformationList({
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    }).then((res) => {
      this.informationList = res.data.records
      if (this.informationList.length >= res.data.totalRecords) {
        this.finished = true
      } else {
        this.finished = false
      }
    }).finally(() => {
      this.refreshing = false
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.pageIndex = 1
    this.refreshing = true
    this.getInformationList()
  }

  /**
   * 上拉加载更多
   */
  onLoad () {
    this.pageIndex++
    this.loading = true
    getInformationList({
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    }).then((res) => {
      this.loading = false
      this.informationList = this.informationList.concat(res.data.records)
      if (this.informationList.length >= res.data.totalRecords) {
        this.finished = true
      }
    }).finally(() => {
      this.refreshing = false
    })
  }
}
